import React from "react";
import { RotateCcw } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";

const HEX_RE = /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

const ColorField = ({ label, value, onChange, defaultValue }) => {
  const { translate } = useLanguage();
  const isInvalid = value !== undefined && value !== "" && value !== null && !HEX_RE.test(value);
  const display = value || defaultValue || "#000000";
  const isDirty = value !== null && value !== undefined && value !== "";

  return (
    <div className="flex items-center gap-3 px-3 py-2.5 rounded-xl"
      style={{ backgroundColor: "var(--color-surface-raised)", border: "1px solid var(--color-border)" }}>
      <label className="flex-1 text-sm" style={{ color: "var(--color-text-primary)" }}>
        {label}
      </label>
      <input
        type="color"
        value={HEX_RE.test(display) ? display : "#000000"}
        onChange={(e) => onChange(e.target.value)}
        className="w-8 h-8 rounded cursor-pointer border-0 p-0"
        style={{ background: "transparent" }}
      />
      <input
        type="text"
        value={value || ""}
        onChange={(e) => onChange(e.target.value || null)}
        placeholder={defaultValue || "#000000"}
        className="field-input"
        style={{
          width: "100px",
          fontFamily: "'JetBrains Mono', monospace",
          fontSize: "12px",
          borderColor: isInvalid ? "var(--color-error)" : undefined,
        }}
      />
      {isDirty ? (
        <button
          type="button"
          onClick={() => onChange(null)}
          title={translate("resetField") || "Reset to default"}
          className="p-1.5 rounded hover:bg-gray-100 transition-colors"
          style={{ color: "var(--color-text-muted)" }}
        >
          <RotateCcw size={14} />
        </button>
      ) : (
        <span className="p-1.5" style={{ width: 28, height: 28 }} aria-hidden="true" />
      )}
    </div>
  );
};

export default ColorField;
